document.addEventListener("DOMContentLoaded", () => {
  const menubar = document.querySelector(".mobile_stickey_menu");
  const quickAddButton = document.querySelector(".product-quick-add");
  const startSection = document.querySelector("header.shopify-section--header");
  const footer = document.querySelector(".footer");
  const buyButton = document.querySelector(
    "#qty-buy-buttons-combine .buy-buttons button"
  );

  let lastScrollY = window.scrollY;

  if (!menubar || !quickAddButton || !startSection || !footer || !buyButton) {
    return;
  }

  const isBetweenSections = () => {
    const startSectionRect = startSection.getBoundingClientRect();
    const footerRect = footer.getBoundingClientRect();
    return startSectionRect.bottom <= window.innerHeight && footerRect.top >= 0;
  };

  const isElementVisible = (element) => {
    const rect = element.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
  };

  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (window.innerWidth <= 767) {
      if (isElementVisible(buyButton)) {
        menubar.classList.add("is-visible");
        quickAddButton.classList.remove("is-visible");
      } else {
        if (isBetweenSections()) {
          if (currentScrollY > lastScrollY) {
            menubar.classList.remove("is-visible");
            quickAddButton.classList.add("is-visible");
          } else {
            if (window.scrollY === 0) {
              menubar.classList.remove("is-visible");
              quickAddButton.classList.add("is-visible");
            } else {
              menubar.classList.add("is-visible");
              quickAddButton.classList.remove("is-visible");
            }
          }
        } else {
          menubar.classList.add("is-visible");
          quickAddButton.classList.remove("is-visible");
        }
      }
    }
    lastScrollY = currentScrollY;
  };

  setTimeout(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll);
  }, 300);
});
